const setAttributes = (el, attr) => {
    Object.keys(attr).forEach(key => el.setAttribute(key, attr[key]))
}
export { setAttributes }